import { getAllValuesForKey } from 'utils/getAllValuesForKey';

export const getAllValidValues = (page: object, keys: string[]): string[] =>
  Object.entries(getAllValuesForKey(page)).reduce(
    (acc: string[], [key, value]: [string, any[]]) =>
      keys.includes(key) ? acc.concat(value.filter(Boolean)) : acc,
    []
  );
